/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disabledContent[_ngcontent-%COMP%]{pointer-events:none;opacity:.8}"];
export { styles as styles };
